/* flipNet: swap one set (net + pole set) for an Additional net of the same size. */
if (!customElements.get('cart-set-swap')) {
  customElements.define(
    'cart-set-swap',
    class CartSetSwap extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.cart-set-swap__button');
        if (this.button && !this.button.dataset.bound) {
          this.button.dataset.bound = '1';
          this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.swap();
          });
        }
      }

      get sizes() {
        // Ordered L then XL; the first entry (L) wins a tie.
        if (this._sizes) return this._sizes;
        return (this._sizes = [
          { size: 'L', set: Number(this.dataset.lSet), an: Number(this.dataset.lAn) },
          { size: 'XL', set: Number(this.dataset.xlSet), an: Number(this.dataset.xlAn) },
        ]);
      }

      sizeForItem(item) {
        const sku = item.sku || '';
        return this.sizes.find((s) => item.variant_id === s.set || sku === `${s.size}_SET_FBA`);
      }

      setBusy(busy) {
        this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.button.disabled = busy;
        this.querySelector('.cart-set-swap__label').classList.toggle('hidden', busy);
        this.querySelector('.cart-set-swap__busy').classList.toggle('hidden', !busy);
      }

      showError(msg) {
        const el = this.querySelector('.cart-set-swap__error');
        el.textContent = msg;
        el.hidden = false;
      }

      async post(url, body) {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Cart error');
        return json;
      }

      async swap() {
        if (this.button.disabled) return;
        this.setBusy(true);
        const r = window.routes || {};
        const changeUrl = `${r.cart_change_url || '/cart/change'}.js`;
        const addUrl = `${r.cart_add_url || '/cart/add'}.js`;
        try {
          const cart = await (await fetch(`${r.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })).json();
          const counts = {};
          let total = 0;
          cart.items.forEach((item) => {
            const s = this.sizeForItem(item);
            if (!s) return;
            counts[s.size] = (counts[s.size] || 0) + item.quantity;
            total += item.quantity;
          });
          if (total < 2) return this.refresh(); // never remove the last set

          let pick = null;
          this.sizes.forEach((s) => {
            if ((counts[s.size] || 0) > 0 && (!pick || counts[s.size] > counts[pick.size])) pick = s;
          });
          // Reduce the biggest line of that size by exactly 1, addressed by line key so no other line changes.
          const line = cart.items
            .filter((item) => (this.sizeForItem(item) || {}).size === pick.size)
            .sort((a, b) => b.quantity - a.quantity)[0];

          await this.post(changeUrl, { id: line.key, quantity: line.quantity - 1 });

          const inDrawer = this.dataset.context === 'drawer' && document.querySelector('cart-drawer');
          const addBody = { items: [{ id: pick.an, quantity: 1 }] };
          if (inDrawer) {
            addBody.sections = ['cart-drawer', 'cart-icon-bubble'];
            addBody.sections_url = window.location.pathname;
          }
          let added;
          try {
            added = await this.post(addUrl, addBody);
          } catch (err) {
            // Put the set back so the customer doesn't lose it.
            await this.post(addUrl, { items: [{ id: line.variant_id, quantity: 1, properties: line.properties || {} }] }).catch(() => {});
            throw err;
          }
          this.refresh(added);
        } catch (err) {
          console.error(err);
          this.setBusy(false);
          this.showError((window.cartStrings && window.cartStrings.error) || 'Sorry, something went wrong. Please try again.');
        }
      }

      refresh(state) {
        const drawer = document.querySelector('cart-drawer');
        if (this.dataset.context === 'drawer' && drawer && state && state.sections && state.sections['cart-drawer']) {
          drawer.renderContents(state);
          if (window.publish && window.PUB_SUB_EVENTS) {
            fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`)
              .then((r) => r.json())
              .then((cartData) => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-set-swap', cartData }))
              .catch(() => {});
          }
        } else {
          window.location.reload();
        }
      }
    }
  );
}
